import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHeart, FaTwitter, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { HiMail, HiPhone, HiLocationMarker } from 'react-icons/hi';

const Footer = () => {
  const footerLinks = {
    Company: [
      { label: 'About Us', path: '/about' },
      { label: 'Our Team', path: '/team' },
      { label: 'Careers', path: '/careers' },
      { label: 'Blog', path: '/blog' },
      { label: 'Contact', path: '/contact' },
    ],
    Features: [
      { label: 'AI Companion', path: '/services' },
      { label: 'Daily Check-ins', path: '/services' },
      { label: 'Health Monitoring', path: '/services' },
      { label: 'Family Connect', path: '/services' },
      { label: 'Emergency Alerts', path: '/services' },
    ],
    Resources: [
      { label: 'Pricing', path: '/pricing' },
      { label: 'FAQ', path: '/faq' },
      { label: 'Testimonials', path: '/testimonials' },
      { label: 'Success Stories', path: '/portfolio' },
      { label: 'Support', path: '/contact' },
    ],
    Legal: [
      { label: 'Privacy Policy', path: '/privacy' },
      { label: 'Terms of Service', path: '/terms' },
      { label: 'Cookie Policy', path: '/privacy' },
      { label: 'HIPAA Compliance', path: '/privacy' },
    ],
  };

  const socials = [
    { icon: FaTwitter, href: '#', color: '#1DA1F2' },
    { icon: FaInstagram, href: '#', color: '#E4405F' },
    { icon: FaLinkedin, href: '#', color: '#0077B5' },
    { icon: FaYoutube, href: '#', color: '#FF0000' },
  ];

  return (
    <footer style={{ background: 'var(--dark-light)', borderTop: '1px solid rgba(224,123,84,0.1)' }}>
      <div className="container" style={{ padding: '80px 20px 30px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.5fr repeat(4, 1fr)', gap: 40, marginBottom: 60 }}>
          <div>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
              <div style={{ width: 40, height: 40, background: 'var(--gradient-1)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FaHeart size={18} />
              </div>
              <span style={{ fontSize: '1.5rem', fontWeight: 800, fontFamily: 'Space Grotesk' }}>
                Maa<span style={{ color: 'var(--primary-light)' }}>Companion</span>
              </span>
            </Link>
            <p style={{ color: 'var(--gray)', marginBottom: 25, lineHeight: 1.8 }}>
              Bringing warmth, care and companionship to every mother through the power of AI and human connection.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--gray-light)' }}>
                <HiMail style={{ color: 'var(--primary-light)' }} /> maa-companion@gmail.com
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--gray-light)' }}>
                <HiPhone style={{ color: 'var(--primary-light)' }} /> +91 7304055630
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--gray-light)' }}>
                <HiLocationMarker style={{ color: 'var(--primary-light)' }} /> Mumbai , India
              </div>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 style={{ fontFamily: 'Space Grotesk', marginBottom: 20, fontSize: '1.1rem' }}>{title}</h4>
              <ul style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} style={{ color: 'var(--gray)', fontSize: '0.95rem', transition: 'all 0.3s' }}
                      onMouseOver={(e) => e.target.style.color = 'var(--primary-light)'}
                      onMouseOut={(e) => e.target.style.color = 'var(--gray)'}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: 30, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 20 }}>
          <p style={{ color: 'var(--gray)', fontSize: '0.9rem' }}>
            © {new Date().getFullYear()} MaaCompanion. Made with <FaHeart style={{ color: 'var(--primary)', display: 'inline' }} /> for every Maa.
          </p>
          <div style={{ display: 'flex', gap: 15 }}>
            {socials.map((s, i) => (
              <motion.a key={i} href={s.href} whileHover={{ scale: 1.2, y: -3 }}
                style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--gray-light)' }}
                onMouseOver={(e) => { e.currentTarget.style.background = s.color; }}
                onMouseOut={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
              >
                <s.icon size={16} />
              </motion.a>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          footer .container > div:first-child { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 600px) {
          footer .container > div:first-child { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;